import { Link } from "react-router-dom";
import { useState } from "react";

const CommonTable = ({
    columns = [],
    data = [],
    actions,
    itemsPerPage = 10,
}) => {
    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = Math.ceil(data.length / itemsPerPage);

    const startIdx = (currentPage - 1) * itemsPerPage;
    const endIdx = startIdx + itemsPerPage;
    const paginatedData = data.slice(startIdx, endIdx);

    return (
        <>
            <div className="common-table">
                <div className="table-wrpper" style={{ overflowX: 'auto', maxWidth: '100%' }}>
                    <table style={{ minWidth: '100%' }}>
                        <thead>
                            <tr>
                                {columns.map((col, idx) => (
                                    <th key={idx}>{col}</th>
                                ))}
                                {actions && <th>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedData.length > 0 ? (
                                paginatedData.map((row, rowIdx) => (
                                    <tr key={rowIdx}>
                                        {columns.map((col, colIdx) => (
                                            <td key={colIdx}>
                                                {row[col]}
                                            </td>
                                        ))}
                                        {actions && (
                                            <td>
                                                <div className="d-flex button-group">
                                                    {actions(row)}
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={columns.length + 1} className="text-center">
                                        No records found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {totalPages > 1 && (
                <div className="table-pagination d-flex align-items-center justify-content-between gap-2 mt-4">
                    <div className="pagination-info">
                        Showing {startIdx + 1} - {Math.min(endIdx, data.length)} of {data.length}
                    </div>
                    <div className="pagination-controls d-flex align-items-center gap-2">
                        <button
                            className="btns-table prev-btn"
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((prev) => prev - 1)}
                        >
                            <i className="icon-icon-10"></i>
                        </button>

                        <button
                            className="btns-table next-btn"
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                        >
                            <i className="icon-icon-9"></i>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default CommonTable;
